import { render, staticRenderFns } from "./DocumentGenerator.vue?vue&type=template&id=ae3391da&scoped=true"
import script from "./DocumentGenerator.vue?vue&type=script&lang=js"
export * from "./DocumentGenerator.vue?vue&type=script&lang=js"
import style0 from "./DocumentGenerator.vue?vue&type=style&index=0&id=ae3391da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3391da",
  null
  
)

export default component.exports